/**
 * 推导营销站（Nuxt）API 根地址：编辑器 dev `:5173` 时请求转发到 `:3000`，生产为当前 origin。
 *
 * @returns 无 `window` 时返回空字符串
 */
export function resolveMarketingApiOrigin(): string {
  if (globalThis.window === undefined) return ''
  const current = globalThis.location
  if (current.port === '5173') {
    return `${current.protocol}//${current.hostname}:3000`
  }
  return `${current.protocol}//${current.host}`
}
